var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.662 5.338 2.72 9.28m.426-2.861-1.931-.456a.279.279 0 0 1-.133-.469L2.617 3.96a.56.56 0 0 1 .39-.164l1.731-.015m2.18-1.98a12.5 12.5 0 0 1 3.283 3.281M5.58 8.854l.456 1.931c.05.213.314.287.468.133l1.536-1.535a.56.56 0 0 0 .163-.39l.015-1.731m2.312-3.087.451-2.168a.836.836 0 0 0-.99-.989l-2.167.45a3.34 3.34 0 0 0-1.685.91L4.362 4.158a4.46 4.46 0 0 0-1.26 2.508l-.006.04a1.94 1.94 0 0 0 2.199 2.198l.04-.006a4.46 4.46 0 0 0 2.508-1.26L9.621 5.86c.462-.461.778-1.047.91-1.685"
  })));
};
export default SvgRocket;